import { LightGallerySettings } from 'lightgallery/lg-settings';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';

export const defaultVideoMaxSize = '1080-1920';

export const defaultLightGallerySettings: LightGallerySettings = {
  counter: true,
  preload: 3,
  licenseKey: '0000-0000-000-0000',
  closeOnTap: false,
  autoplayFirstVideo: false,
  escKey: true,
  keyPress: true,
  controls: true,
  dynamic: true,
  allowMediaOverlap: false,
  mobileSettings: {
    controls: true,
  },
  strings: {
    closeGallery: $localize`:@@lg-close-gallery:Close gallery`,
    toggleMaximize: $localize`:@@lg-toggle-maximize:Toggle maximize`,
    previousSlide: $localize`:@@lg-previous-slide:Previous slide`,
    nextSlide: $localize`:@@lg-next-slide:Next slide`,
    download: $localize`:@@lg-download:Download`,
    playVideo: $localize`:@@lg-play-video:Play video`,
    mediaLoadingFailed: $localize`:@@lg-media-loading-failed:Oops... Failed to load content...`,
  },
  plugins: [lgThumbnail, lgVideo],
};
